import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

const BankAccountSummary = ({ bankAccountsSummary }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1} pt="1" sx={{ fontSize: "14px" }}>
      <Grid item xs={4}>
        <strong>{t("BankAccount.Name")}</strong> : <span>{bankAccountsSummary?.partnerName}</span>
      </Grid>
      <Grid item xs={4}>
        <strong>{t("BankAccount.Account")}</strong> : <span>{bankAccountsSummary?.bankAccount}</span>
      </Grid>
      <Grid item xs={4}>
        <strong>{t("BankAccount.Currency")}</strong> : <span>{bankAccountsSummary?.currencyName}</span>
      </Grid>
    </Grid>
  );
};

BankAccountSummary.propTypes = {
  bankAccountsSummary: PropTypes.object
};

export default BankAccountSummary;
